export default __webpack_public_path__ + "static/media/toShow-5-min.034ec625.jpg";